import { handleActions } from 'redux-actions';
import { State, stateUpdate, stateClear } from './action';

const initialState: State = {
  serverErrors: {},
};

const reducer = handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(stateClear)]: () => {
      return initialState;
    },
  },
  initialState,
);

export default reducer;
